// Types of errors in the application
export enum Error {
  Console = "console",
  Route = "route",
}
export enum Page {
  None = "None",
  Redirect = "redirect",
  Reload = "reload",
}

// Error boundary props type
export type ErrorBoundaryPropsType = {
  error: Error;
  pageAction?: Page;
};

// Handler function type
export type HandleButtonOnClickType = (action: Page) => () => void;
